<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/inventory.webp"
    i18n
  >
    Manage and track inventory seamlessly. Automate actions for key inventory events like adding, deleting, marking as
    damaged, or designating as inoperable. Ensuring accurate records improves operational efficiency and resource
    availability.
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when an inventory item is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.InventoryCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.InventoryCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.InventoryUpdated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.InventoryUpdated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Updated
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.InventoryDeleted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.InventoryDeleted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Deleted
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.InventoryDamaged)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.InventoryDamaged ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Damaged
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.InventoryInoperable)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.InventoryInoperable ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Inoperable
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.InventoryDepleted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.InventoryDepleted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Depleted
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.InventoryCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InventoryUpdated" [ngTemplateOutlet]="updatedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InventoryDeleted" [ngTemplateOutlet]="deletedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InventoryDamaged" [ngTemplateOutlet]="damagedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InventoryInoperable" [ngTemplateOutlet]="inoperableEvent"></ng-template>
        <ng-template *ngSwitchCase="events.InventoryDepleted" [ngTemplateOutlet]="depletedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Inventory item is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Inventory item is Updated</h6>
    <ng-template [ngTemplateOutlet]="updatedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Inventory item is Deleted</h6>
    <ng-template [ngTemplateOutlet]="deletedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Inventory item is Damaged</h6>
    <ng-template [ngTemplateOutlet]="damagedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Inventory item is Inoperable</h6>
    <ng-template [ngTemplateOutlet]="inoperableEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 i18n class="text-uppercase m-0 px-3 py-2">Inventory item is Depleted</h6>
    <ng-template [ngTemplateOutlet]="depletedEvent"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-notify-users-automation
    [event]="events.InventoryCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when inventory item created"
    [messageSubject]="userNotificationMessages[events.InventoryCreated].subject"
    [messageBody]="userNotificationMessages[events.InventoryCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-task-automation
    [event]="events.InventoryCreated"
    [handler]="eventHandlers.InventoryCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [hideDateFields]="true"
    i18n-label
    label="Create a task for further inspection if needed when inventory created"
    [task]="taskForFurtherInspection"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>
</ng-template>

<ng-template #updatedEvent>
  <app-notify-users-automation
    [event]="events.InventoryUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when inventory updated"
    [messageSubject]="userNotificationMessages[events.InventoryUpdated].subject"
    [messageBody]="userNotificationMessages[events.InventoryUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #deletedEvent>
  <app-notify-users-automation
    [event]="events.InventoryDeleted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when inventory deleted"
    [messageSubject]="userNotificationMessages[events.InventoryDeleted].subject"
    [messageBody]="userNotificationMessages[events.InventoryDeleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #damagedEvent>
  <app-notify-users-automation
    [event]="events.InventoryDamaged"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when inventory damaged"
    [messageSubject]="userNotificationMessages[events.InventoryDamaged].subject"
    [messageBody]="userNotificationMessages[events.InventoryDamaged].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-incident-automation
    [event]="events.InventoryDamaged"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Create Incident"
    name="Create an incident for inventory damaged"
    [incident]="damagedIncident"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-incident-automation>

  <app-new-task-automation
    [event]="events.InventoryDamaged"
    [handler]="eventHandlers.InventoryCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [hideDateFields]="true"
    i18n-label
    label="Create a task to repair or replace the item"
    [task]="taskForRepair"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>
</ng-template>

<ng-template #inoperableEvent>
  <app-notify-users-automation
    [event]="events.InventoryInoperable"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) when inventory inoperable"
    [messageSubject]="userNotificationMessages[events.InventoryInoperable].subject"
    [messageBody]="userNotificationMessages[events.InventoryInoperable].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-incident-automation
    [event]="events.InventoryInoperable"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Create Incident"
    name="Create an incident for inventory inoperable"
    [incident]="inoperableIncident"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-incident-automation>

  <app-new-task-automation
    [event]="events.InventoryInoperable"
    [handler]="eventHandlers.InventoryCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [hideDateFields]="true"
    i18n-label
    label="Create a task to dispose of or replace the item"
    [task]="taskForDispose"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>
</ng-template>

<ng-template #depletedEvent>
  <app-new-task-automation
    [event]="events.InventoryDepleted"
    [handler]="eventHandlers.InventoryCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [hideDateFields]="true"
    i18n-label
    label="Create a task to automatically replenish the inventory."
    [task]="taskForAutoReplenish"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>
</ng-template>
